module.exports = __webpack_public_path__ + "img/cash-promo.97aa1fb.webp";